<template>
  <div class="leifeng-setting">
    <el-card class="main-card">
      <div class="header-section">
        <h2 class="page-title">
          <i class="el-icon-setting title-icon"></i>
          雷锋e站设置管理
        </h2>
        <el-tabs v-model="activeTab" class="tabs-box">
          <el-tab-pane label="设置管理" name="settings">
          </el-tab-pane>
          <el-tab-pane label="标签管理" name="tags">
          </el-tab-pane>
        </el-tabs>
      </div>
      
      <div class="content-section">
        <!-- 设置列表 -->
        <div v-if="activeTab === 'settings'" class="table-wrapper">
          <div class="table-container" v-loading="tableLoading">
            <el-table :data="settingList" style="width: 100%" border>
              <el-table-column prop="id" label="ID" width="80"></el-table-column>
              <el-table-column prop="key" label="配置键" min-width="200"></el-table-column>
              <el-table-column prop="value" label="配置值" min-width="120"></el-table-column>
              <el-table-column prop="description" label="说明" min-width="300"></el-table-column>
              <el-table-column prop="create_time_str" label="创建时间" width="180"></el-table-column>
              <el-table-column prop="update_time_str" label="更新时间" width="180"></el-table-column>
              <el-table-column label="操作" width="120" fixed="right">
                <template slot-scope="scope">
                  <el-button size="small" icon="el-icon-edit" @click="openEditDialog(scope.row)">编辑</el-button>
                </template>
              </el-table-column>
            </el-table>
            
            <!-- 空状态 -->
            <div v-if="settingList.length === 0 && !tableLoading" class="empty-state">
              <i class="el-icon-setting empty-icon"></i>
              <p class="empty-text">暂无配置数据</p>
            </div>
            
            <!-- 分页 -->
            <el-pagination
              class="pagination-box"
              :pager-count="7"
              @current-change="pageChange"
              @size-change="sizeChange"
              :page-sizes="[30, 60, 100]"
              layout="total, sizes, prev, pager, next, jumper"
              :page-size="query.limit"
              background
              :total="exp.total"
            />
          </div>
        </div>
        
        <!-- 标签列表 -->
        <div v-if="activeTab === 'tags'" class="table-wrapper">
          <div class="search-bar">
            <el-input
              placeholder="请输入标签名称搜索"
              v-model="tagQuery.info"
              clearable
              style="width: 300px"
              @keyup.enter.native="getTagList"
            >
              <el-button
                slot="append"
                icon="el-icon-search"
                @click="getTagList"
              ></el-button>
            </el-input>
            <el-button type="primary" icon="el-icon-plus" @click="openTagDialog()">添加标签</el-button>
          </div>
          <div class="table-container" v-loading="tagLoading">
            <el-table :data="tagList" style="width: 100%" border>
              <el-table-column prop="id" label="ID" width="80"></el-table-column>
              <el-table-column prop="name" label="标签名称" min-width="150"></el-table-column>
              <el-table-column prop="sort" label="排序" width="80"></el-table-column>
              <el-table-column prop="color" label="颜色" width="100">
                <template slot-scope="scope">
                  <el-tag :color="scope.row.color || 'default'">{{ scope.row.color || '默认' }}</el-tag>
                </template>
              </el-table-column>
              <el-table-column prop="status" label="状态" width="100">
                <template slot-scope="scope">
                  <el-tag v-if="scope.row.status === 1" type="success">启用</el-tag>
                  <el-tag v-else type="warning">禁用</el-tag>
                </template>
              </el-table-column>
              <el-table-column prop="create_time" label="创建时间" width="180"></el-table-column>
              <el-table-column label="操作" width="200" fixed="right">
                <template slot-scope="scope">
                  <el-button size="small" icon="el-icon-edit" @click="openTagDialog(scope.row)">编辑</el-button>
                  <el-button size="small" type="danger" icon="el-icon-delete" @click="handleDeleteTag(scope.row)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
            
            <!-- 空状态 -->
            <div v-if="tagList.length === 0 && !tagLoading" class="empty-state">
              <i class="el-icon-tags empty-icon"></i>
              <p class="empty-text">暂无标签数据</p>
            </div>
            
            <!-- 分页 -->
            <el-pagination
              class="pagination-box"
              :pager-count="7"
              @current-change="tagPageChange"
              @size-change="tagSizeChange"
              :page-sizes="[30, 60, 100]"
              layout="total, sizes, prev, pager, next, jumper"
              :page-size="tagQuery.limit"
              background
              :total="tagExp.total"
            />
          </div>
        </div>
      </div>
    </el-card>
    
    <!-- 编辑配置弹窗 -->
    <el-dialog
      v-dialogDrag
      title="编辑配置"
      :visible.sync="editVisible"
      width="500px"
      class="edit-dialog"
    >
      <el-form :model="editForm" label-width="100px" class="edit-form">
        <el-form-item label="配置键">
          <el-input v-model="editForm.key" disabled></el-input>
        </el-form-item>
        <el-form-item label="配置值">
          <el-input v-model="editForm.value" placeholder="请输入配置值"></el-input>
        </el-form-item>
        <el-form-item label="说明">
          <el-input v-model="editForm.description" type="textarea" :rows="3" disabled></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editVisible = false">取消</el-button>
        <el-button type="primary" :loading="btnLoading" @click="saveSetting">保存</el-button>
      </div>
    </el-dialog>
    
    <!-- 添加/编辑标签弹窗 -->
    <el-dialog
      v-dialogDrag
      :title="tagDialogTitle"
      :visible.sync="tagDialogVisible"
      width="500px"
      class="edit-dialog"
    >
      <el-form :model="tagForm" label-width="100px" class="edit-form">
        <el-form-item label="标签名称" required>
          <el-input v-model="tagForm.name" placeholder="请输入标签名称"></el-input>
        </el-form-item>
        <el-form-item label="排序">
          <el-input-number v-model="tagForm.sort" :min="0" :max="999" placeholder="排序值"></el-input-number>
        </el-form-item>
        <el-form-item label="颜色">
          <el-select v-model="tagForm.color" placeholder="请选择颜色">
            <el-option label="默认" value="default"></el-option>
            <el-option label="蓝色" value="blue"></el-option>
            <el-option label="绿色" value="green"></el-option>
            <el-option label="金色" value="gold"></el-option>
            <el-option label="红色" value="red"></el-option>
            <el-option label="紫色" value="purple"></el-option>
            <el-option label="橙色" value="orange"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态">
          <el-radio-group v-model="tagForm.status">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="0">禁用</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="tagDialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="btnLoading" @click="saveTag">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  settingsList,
  settingsUpdate,
  getTagList,
  addTag,
  updateTag,
  deleteTag,
} from '@/api/zhiqing/shop.js'

export default {
  name: 'LeifengSetting',
  data() {
    return {
      activeTab: 'settings',
      tableLoading: false,
      tagLoading: false,
      exp: { total: 0 },
      tagExp: { total: 0 },
      btnLoading: false,
      query: {
        page: 1,
        limit: 20,
      },
      tagQuery: {
        info: '',
        page: 1,
        limit: 20,
      },
      settingList: [],
      tagList: [],
      editVisible: false,
      tagDialogVisible: false,
      tagDialogTitle: '添加标签',
      editForm: {
        id: '',
        key: '',
        value: '',
        description: '',
      },
      tagForm: {
        id: '',
        name: '',
        sort: 0,
        color: '',
        status: 1,
      },
    }
  },
  created() {
    this.getList()
  },
  watch: {
    activeTab(newVal) {
      if (newVal === 'tags') {
        this.getTagList()
      }
    },
  },
  methods: {
    async getList() {
      this.tableLoading = true
      try {
        const { data: res } = await settingsList(this.query)
        console.log('设置列表完整返回:', res)
        if (res.code === 200 || res.code === 1 || res.code === 0) {
          this.settingList = res.data.list || res.list || []
          this.exp.total = res.data.total || res.total || this.settingList.length
        } else {
          this.$message.error(res.message || '获取设置列表失败')
        }
      } catch (error) {
        console.error('获取设置列表错误:', error)
        this.$message.error('网络错误，请稍后重试')
      } finally {
        this.tableLoading = false
      }
    },
    pageChange(page) {
      this.query.page = page
      this.getList()
    },
    sizeChange(size) {
      this.query.limit = size
      this.query.page = 1
      this.getList()
    },
    openEditDialog(row) {
      this.editForm = {
        id: row.id,
        key: row.key,
        value: row.value,
        description: row.description,
      }
      this.editVisible = true
    },
    async saveSetting() {
      if (!this.editForm.value.trim()) {
        this.$message.warning('请输入配置值')
        return
      }
      this.btnLoading = true
      try {
        const { data: res } = await settingsUpdate({
          id: this.editForm.id,
          value: this.editForm.value,
        })
        if (res.code === 200 || res.code === 1 || res.code === 0) {
          this.$message.success('保存成功')
          this.editVisible = false
          this.getList()
        } else {
          this.$message.error(res.message || '保存失败')
        }
      } catch (error) {
        this.$message.error('网络错误，请稍后重试')
      } finally {
        this.btnLoading = false
      }
    },
    async getTagList() {
      this.tagLoading = true
      try {
        const { data: res } = await getTagList(this.tagQuery)
        if (res.code === 200 || res.code === 1 || res.code === 0) {
          this.tagList = res.data || []
          this.tagExp.total = res.data ? res.data.length : 0
          if (res.exp) {
            this.tagExp.total = res.exp.num || res.exp.total || this.tagExp.total
          }
        } else {
          this.$message.error(res.message || '获取标签列表失败')
        }
      } catch (error) {
        this.$message.error('网络错误，请稍后重试')
      } finally {
        this.tagLoading = false
      }
    },
    tagPageChange(page) {
      this.tagQuery.page = page
      this.getTagList()
    },
    tagSizeChange(size) {
      this.tagQuery.limit = size
      this.tagQuery.page = 1
      this.getTagList()
    },
    openTagDialog(row) {
      if (row) {
        this.tagDialogTitle = '编辑标签'
        this.tagForm = {
          id: row.id,
          name: row.name,
          sort: row.sort || 0,
          color: row.color || '',
          status: row.status !== undefined ? Number(row.status) : 1,
        }
      } else {
        this.tagDialogTitle = '添加标签'
        this.tagForm = {
          id: '',
          name: '',
          sort: 0,
          color: '',
          status: 1,
        }
      }
      this.tagDialogVisible = true
    },
    async saveTag() {
      if (!this.tagForm.name.trim()) {
        this.$message.warning('请输入标签名称')
        return
      }
      this.btnLoading = true
      try {
        const api = this.tagForm.id ? updateTag : addTag
        const { data: res } = await api(this.tagForm)
        if (res.code === 200 || res.code === 1 || res.code === 0) {
          this.$message.success(this.tagForm.id ? '编辑成功' : '添加成功')
          this.tagDialogVisible = false
          this.getTagList()
        } else {
          this.$message.error(res.message || '操作失败')
        }
      } catch (error) {
        this.$message.error('网络错误，请稍后重试')
      } finally {
        this.btnLoading = false
      }
    },
    async handleDeleteTag(row) {
      this.$confirm(`确认删除标签「${row.name}」?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          this.btnLoading = true
          try {
            const { data: res } = await deleteTag({ id: row.id })
            if (res.code === 200 || res.code === 1 || res.code === 0) {
              this.$message.success('删除成功')
              this.getTagList()
            } else {
              this.$message.error(res.message || '删除失败')
            }
          } catch (error) {
            this.$message.error('网络错误，请稍后重试')
          } finally {
            this.btnLoading = false
          }
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          })
        })
    },
  },
}
</script>

<style scoped>
.leifeng-setting {
  padding: 20px;
  background: #f5f7fa;
  min-height: calc(100vh - 120px);
}

.main-card {
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.08);
  border: none;
}

.header-section {
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 2px solid #f0f2f5;
}

.page-title {
  font-size: 20px;
  font-weight: 600;
  color: #303133;
  margin: 0;
  display: flex;
  align-items: center;
  gap: 10px;
}

.title-icon {
  font-size: 24px;
  color: #409eff;
}

.tabs-box {
  margin-top: 16px;
}

.content-section {
  background: #fff;
}

.table-wrapper {
  background: #fff;
  border-radius: 8px;
}

.search-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  border-bottom: 1px solid #f0f2f5;
}

.table-container {
  padding: 10px 0;
}

.empty-state {
  text-align: center;
  padding: 60px 20px;
}

.empty-icon {
  font-size: 64px;
  color: #dcdfe6;
  margin-bottom: 16px;
}

.empty-text {
  font-size: 14px;
  color: #909399;
  margin: 0;
}

.pagination-box {
  margin-top: 24px;
  text-align: center;
  padding: 10px 0;
}

.edit-dialog {
  border-radius: 8px;
}

.edit-form {
  padding: 10px 0;
}

.dialog-footer {
  text-align: center;
}
</style>